import { render, staticRenderFns } from "./loadingDialog.vue?vue&type=template&id=496bc892&lang=pug"
import script from "./loadingDialog.vue?vue&type=script&lang=js"
export * from "./loadingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports